import { Redirect } from "react-router-dom";

import Loading from "@/components/Loading";
import { hasReportEntitlement } from "@/components/reports/reportListClick";
import { ERROR_404_URL } from "@/core/urls";
import { gql, useQuery } from "@apollo/client";

const NOOP_QUERY = gql`
  query ReportsRouteGuardNoop {
    __typename
  }
`;

export default function ReportsRouteGuard({
  children,
  reportsQuery,
  reportsQueryVariables = {},
  entitlementsQuery,
  entitlementsQueryVariables = {},
  userEntitlements,
  skip = false
}) {
  const entitlementsFromQuery = !!entitlementsQuery;

  const { data: reportsData, loading: reportsLoading } = useQuery(reportsQuery, {
    variables: reportsQueryVariables,
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first",
    skip
  });

  const { data: entitlementsData, loading: entitlementsLoading } = useQuery(
    entitlementsQuery || NOOP_QUERY,
    {
      variables: entitlementsQueryVariables,
      fetchPolicy: "cache-first",
      nextFetchPolicy: "cache-first",
      skip: skip || !entitlementsFromQuery
    }
  );

  if (skip || reportsLoading || (entitlementsFromQuery && entitlementsLoading)) {
    return <Loading />;
  }

  const resolvedEntitlements = userEntitlements ?? entitlementsData?.user?.entitlements;

  const showReportsTab = entitlementsFromQuery
    ? !!reportsData &&
      !!entitlementsData &&
      hasReportEntitlement({
        reports: reportsData.reports,
        userEntitlements: resolvedEntitlements
      })
    : !!userEntitlements &&
      !!reportsData &&
      hasReportEntitlement({
        reports: reportsData.reports,
        userEntitlements: resolvedEntitlements
      });

  if (!showReportsTab) {
    return <Redirect to={ERROR_404_URL} />;
  }

  return children;
}
